import Marquee from 'react-fast-marquee';

const WORDS = [
  'PRECISION ENGINEERING',
  'CRGO TRANSFORMER CORE',
  'SINCE 1977',
  'GUARANTEED LOSSES',
  'EXPORT TO 16 COUNTRIES',
  'ISO 9001:2015',
];

export default function EditorialMarquee({ dark = false }) {
  return (
    <div
      data-testid="editorial-marquee"
      className={`border-y ${dark ? 'border-white/10 bg-navy' : 'border-line bg-white'} py-6`}
    >
      <Marquee speed={40} gradient={false}>
        {WORDS.concat(WORDS).map((w, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span
              className={`font-display text-2xl font-semibold tracking-tight sm:text-3xl ${
                dark ? 'text-white/90' : 'text-navy'
              }`}
            >
              {w}
            </span>
            <span className="h-2 w-2 rounded-full bg-brand" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
